import styled from 'styled-components';
import { underIPhone5 } from '@westwing/ui-kit/breakPoints';

export default styled.p`
    font-size: 1em;
    width: 280px;
    margin: auto;
    text-align: center;
    margin-bottom: 10px;

    ${underIPhone5`
        display: none;
    `}
`;
